// rfc tab for boilerplate
import React, { useEffect, useState } from 'react';
import { Grid, Button, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogActions } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import useRequestResource from '../../hooks/useRequestResource';
import ColorBox from "../../components/ColorBox";
import {Search, SearchIconWrapper, StyledInputBase} from '../../components/utils/SearchBar'
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { FaSort, FaSortDown, FaSortUp} from "react-icons/fa";

export default function LocationList() {
    const {getResourceList, resourceList, deleteResource, searchResources, searchList, currentListSize} = useRequestResource({ endpoint: "auth", query: `locations`, resourceLabel: "location List" });
    const [open, setOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    let offset = 25;
    const [exp, setExp] = useState("")
    const [sorting_query, setSortingQuery] = useState(null)

    useEffect(() => {
        getResourceList();
    }, [getResourceList])

    const handleConfirmDelete = (id) => {
        setIdToDelete(id);
        setOpen(true);
    }

    const handleDeleteClose = () => {
        setOpen(false);
    }

    const handleDelete = () => {
        setOpen(false);
        deleteResource(idToDelete);
    }

    const fetchData = () => {
        getResourceList(offset, sorting_query)
    }

    const headerStyle = {
        color: "white",
        backgroundColor: "Green",
        padding: "10px",
        fontFamily: "Arial"
    };

    const is_manager = localStorage.getItem("is_manager")
    const has_edit_access = (is_manager === "true")

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            searchData();
        }
    };

    useEffect(() => {
        if (exp !== "") {
            searchData()
        } else {
            getResourceList(0, sorting_query)
        }
    }, [sorting_query, getResourceList])

    function changeSort(elem) {
        setSortingQuery(elem)
    }

    function toggleSort(elem) {
        if (sorting_query === elem || sorting_query === `-${elem}`) {
            setSortingQuery(null)
        } else {
            setSortingQuery(elem)
        }
    }

    const searchData = () => {
        searchResources(exp, sorting_query)
    }

    const getList = () => {
        if (exp !== "") {
            return searchList.results
        } else {
            return resourceList.results
        }
    }

    return (
        <div>
            <Dialog open={open} onClose={handleDeleteClose}>
                <DialogTitle>
                    Are you sure you want to delete this??
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleDelete}>
                        YES
                    </Button>
                    <Button onClick={handleDeleteClose}>
                        NO
                    </Button>
                </DialogActions>
            </Dialog>

            { has_edit_access ?
                <Grid item xs={12} >
                    <Grid item xs={12} align="left">
                        <Link
                            to="/createlocation" 
                            key="location"
                        >
                            <Button 
                            size="medium"
                            variant="contained"
                            color="primary"
                            >
                                <AddIcon></AddIcon>
                                Create New Location
                            </Button>
                        </Link>
                    </Grid>
                </Grid>
            : <div></div>}

            <div style={{ height: "20px" }} />

            <TableContainer component={Paper}>
            <h3 style={headerStyle}>
                    Location List
                </h3>

                 
                <Grid item xs={12} >
                    <Search fullWidth>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }}
                            fullWidth
                            id="Location"
                            label="Location"
                            value={exp}
                            onChange={(e) => setExp(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                    </Search>
                </Grid>
                
                <div style={{ height: "20px" }} />
                
                <Table sx={{ minWidth: 360 }} size="small">
                    <TableHead width="100%">
                        <TableRow>
                            <TableCell align="center" width="35%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("location_name")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Location Name</div><div>{sorting_query === "location_name" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-location_name")}></FaSortUp> : 
                                    sorting_query === "-location_name" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("location_name")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="35%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("latitude")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Latitude</div><div>{sorting_query === "latitude" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-latitude")}></FaSortUp> : 
                                    sorting_query === "-latitude" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("latitude")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="30%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("longitude")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Longitude</div><div>{sorting_query === "longitude" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-longitude")}></FaSortUp> : 
                                    sorting_query === "-longitude" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("longitude")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="30%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("altitude")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Altitude</div><div>{sorting_query === "altitude" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-altitude")}></FaSortUp> : 
                                    sorting_query === "-altitude" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("altitude")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="30%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("postal_code")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Postal Code</div><div>{sorting_query === "postal_code" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-postal_code")}></FaSortUp> : 
                                    sorting_query === "-postal_code" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("postal_code")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            { has_edit_access ? <TableCell align="right" width="25%">
                                Action
                            </TableCell> : <div></div>}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            getList().map((r) => {
                                return (
                                    <TableRow key={r.id}>
                                        <TableCell align="center" width="35%">
                                            {r.location_name}
                                        </TableCell>
                                        <TableCell align="center" width="35%">
                                            {r.latitude}
                                        </TableCell>
                                        <TableCell align="center" width="30%">
                                            {r.longitude}
                                        </TableCell>
                                        <TableCell align="center" width="30%">
                                            {r.altitude}
                                        </TableCell>
                                        <TableCell align="center" width="30%">
                                            {r.postal_code}
                                        </TableCell>
                                        { has_edit_access ? <TableCell align="center" width="20%">
                                            <Box sx={{ display: "flex", justifyContent: "flex-end" }} >
                                                <Link to={`/${r.id}/editlocation`} key="Location-Edit">
                                                    <IconButton size="large">
                                                        <EditIcon />
                                                    </IconButton>
                                                </Link>
                                                <IconButton size="large" onClick={() => {
                                                    handleConfirmDelete(r.id)
                                                }}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Box>
                                        </TableCell> : <div></div>}
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
                
            </TableContainer>
            {exp !== "" || currentListSize.current < offset ? <div></div> : <div className='centered-container'>
                <Button onClick={fetchData}>
                            LOAD MORE!
                </Button>
            </div>}
        </div>
    )
}
